/* Bazan Premium Line PDP — behaviour for bz-prm-* sections.
   Safe to load multiple times (guarded). Re-inits on theme editor section load. */
(function () {
  'use strict';
  if (window.__bzPrm) return;
  window.__bzPrm = true;
  document.documentElement.classList.add('prm-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, format) {
    format = format || '${{amount}}';
    var v = (cents || 0) / 100;
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return noDec.replace(/,/g, '.');
      return withDec;
    });
  }
  function pct(full, now) {
    if (!full || !now || now >= full) return 0;
    return Math.round((1 - now / full) * 100);
  }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------------- Buy box ---------------- */
  function Main(root) {
    this.root = root;
    this.variants = JSON.parse($(root, '[data-prm-variants]').textContent);
    this.cfg = JSON.parse($(root, '[data-prm-cfg]').textContent);
    this.gi = parseInt(root.getAttribute('data-grind-index'), 10);
    this.si = parseInt(root.getAttribute('data-size-index'), 10);
    this.fmt = root.getAttribute('data-money-format');
    this.hideNa = root.getAttribute('data-hide-na') === 'true';
    this.form = $(root, '.prm-form');
    this.idInput = $(root, '[data-prm-id]');
    this.planInput = $(root, '[data-prm-plan-input]');
    this.planSel = $(root, '[data-prm-plan]');
    this.toggle = $(root, '[data-prm-refill-toggle]');
    this.refill = $(root, '[data-prm-refill]');
    this.cta = $(root, '[data-prm-cta]');
    this.sticky = $(root, '[data-prm-sticky]');

    var self = this;
    var init = this.find(function (v) { return String(v.id) === self.idInput.value; }) || this.variants[0];
    this.opts = init.options.slice();

    var hasUrlVariant = /[?&]variant=/.test(window.location.search);
    var ds = root.getAttribute('data-default-size');
    if (!hasUrlVariant && ds && this.si >= 0) {
      var t = this.opts.slice(); t[this.si] = ds;
      if (this.match(t)) this.opts = t;
    }
    this.sub = !!(this.toggle && this.toggle.checked);

    $$(root, '[data-prm-grind]').forEach(function (b) {
      b.addEventListener('click', function () { self.pickGrind(b.getAttribute('data-prm-grind')); });
    });
    $$(root, '[data-prm-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.closest('[data-prm-size-wrap]').classList.contains('is-na')) return;
        self.pickSize(b.getAttribute('data-prm-size'));
      });
    });
    [$$(root, '.prm-grind'), $$(root, '.prm-sizes')].forEach(function (groups) {
      groups.forEach(function (g) { g.addEventListener('keydown', function (e) { self.arrowNav(e, g); }); });
    });
    if (this.toggle) this.toggle.addEventListener('change', function () { self.sub = self.toggle.checked; self.render(); });
    if (this.planSel) this.planSel.addEventListener('change', function () { self.render(); });

    // Only our own selling_plan / id reach the cart: apps that auto-inject a
    // purchase widget into the form (e.g. Seal) add their own hidden inputs.
    this.form.addEventListener('formdata', function (e) {
      var v = self.current(), a = self.allocFor(v);
      e.formData.delete('selling_plan');
      if (self.sub && a) e.formData.set('selling_plan', self.planId());
      if (v) e.formData.set('id', v.id);
    });
    this.form.addEventListener('submit', function () {
      $$(self.form, '[name="selling_plan"]').forEach(function (el) { if (el !== self.planInput) el.disabled = true; });
    }, true);

    this.bindGallery();
    this.bindSticky();
    this.bindAjaxCart();
    this.render(true);
  }
  Main.prototype.find = function (fn) {
    for (var i = 0; i < this.variants.length; i++) if (fn(this.variants[i])) return this.variants[i];
    return null;
  };
  Main.prototype.match = function (opts) {
    return this.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
  };
  Main.prototype.current = function () { return this.match(this.opts); };
  Main.prototype.planId = function () { return this.planSel ? parseInt(this.planSel.value, 10) : null; };
  Main.prototype.allocFor = function (v) {
    if (!v || !this.planSel) return null;
    var id = this.planId(), list = v.selling_plan_allocations || [];
    for (var i = 0; i < list.length; i++) if (list[i].selling_plan_id === id) return list[i];
    return null;
  };
  Main.prototype.pickGrind = function (val) {
    var t = this.opts.slice(); t[this.gi] = val;
    if (!this.match(t)) {
      var gi = this.gi;
      var alt = this.find(function (v) { return v.options[gi] === val && v.available; }) ||
                this.find(function (v) { return v.options[gi] === val; });
      if (!alt) return;
      t = alt.options.slice();
    }
    this.opts = t; this.render();
  };
  Main.prototype.pickSize = function (val) {
    var t = this.opts.slice(); t[this.si] = val;
    if (!this.match(t)) return;
    this.opts = t; this.render();
  };
  Main.prototype.arrowNav = function (e, group) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!keys[e.key]) return;
    var items = $$(group, '[role="radio"]').filter(function (b) {
      var w = b.closest('[data-prm-size-wrap]');
      return !(w && (w.hidden || w.classList.contains('is-na')));
    });
    var i = items.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var next = items[(i + keys[e.key] + items.length) % items.length];
    next.focus(); next.click();
  };
  Main.prototype.render = function (first) {
    var self = this, v = this.current() || this.variants[0], fmt = this.fmt;
    var alloc = this.allocFor(v);
    var subOn = this.sub && !!alloc;

    this.idInput.value = v.id;
    if (this.planInput) {
      this.planInput.disabled = !subOn;
      if (subOn) this.planInput.value = this.planId();
    }
    if (this.refill) this.refill.classList.toggle('is-on', this.sub);

    // grind buttons
    $$(this.root, '[data-prm-grind]').forEach(function (b) {
      var on = b.getAttribute('data-prm-grind') === self.opts[self.gi];
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });

    // size cards
    $$(this.root, '[data-prm-size]').forEach(function (b) {
      var val = b.getAttribute('data-prm-size');
      var wrap = b.closest('[data-prm-size-wrap]');
      var t = self.opts.slice(); t[self.si] = val;
      var vv = self.match(t);
      var on = val === self.opts[self.si];
      wrap.classList.toggle('is-na', !vv);
      wrap.hidden = !vv && self.hideNa;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('aria-disabled', vv ? 'false' : 'true');
      b.tabIndex = on ? 0 : -1;
      var p = $(b, '[data-prm-card-price]'), w = $(b, '[data-prm-card-was]'), s = $(b, '[data-prm-card-save]');
      if (!vv) { p.textContent = ''; w.textContent = ''; s.textContent = ''; return; }
      var a = self.sub ? self.allocFor(vv) : null;
      var now = a ? a.price : vv.price;
      var was = a ? vv.price : (vv.compare_at_price > vv.price ? vv.compare_at_price : 0);
      var off = pct(was, now);
      p.textContent = money(now, fmt);
      w.textContent = was && off ? money(was, fmt) : '';
      s.textContent = off ? self.cfg.saveText.replace('[pct]', off) : '';
    });

    // header price
    var now = subOn ? alloc.price : v.price;
    var was = subOn ? v.price : (v.compare_at_price > v.price ? v.compare_at_price : 0);
    var off = pct(was, now);
    $(this.root, '[data-prm-now]').textContent = money(now, fmt);
    var wasEl = $(this.root, '[data-prm-was]'), saveEl = $(this.root, '[data-prm-save]');
    wasEl.hidden = !off; wasEl.textContent = off ? money(was, fmt) : '';
    saveEl.hidden = !off; saveEl.textContent = off ? this.cfg.saveText.replace('[pct]', off) : '';
    $(this.root, '[data-prm-hint]').textContent = subOn
      ? this.cfg.hintSub.replace('[price]', money(v.price, fmt))
      : (this.planSel ? this.cfg.hintOnce : '');

    // refill pill + recurring line (always from the plan, even when off)
    var rs = $(this.root, '[data-prm-refill-save]');
    if (rs) {
      var ro = alloc ? pct(v.price, alloc.price) : 0;
      rs.hidden = !ro; rs.textContent = ro ? this.cfg.saveText.replace('[pct]', ro) : '';
    }
    var then = $(this.root, '[data-prm-then]');
    if (then) {
      // recurring price = last price adjustment (e.g. 25% first order, 20% after)
      var adj = alloc && alloc.price_adjustments ? alloc.price_adjustments : [];
      var rec = adj.length > 1 ? adj[adj.length - 1].price : (alloc ? (alloc.per_delivery_price || alloc.price) : 0);
      then.textContent = alloc ? this.cfg.thenText.replace('[price]', money(rec, fmt)) : '';
    }

    // CTA
    var label = !v.available ? this.cfg.soldOut : (subOn ? this.cfg.ctaSub : this.cfg.ctaOnce);
    this.cta.disabled = !v.available;
    $(this.cta, '[data-prm-cta-label]').textContent = label;

    // sticky
    if (this.sticky) {
      var gb = this.gi >= 0 ? $(this.root, '[data-prm-grind][aria-checked="true"]') : null;
      $(this.sticky, '[data-prm-sticky-grind]').textContent = gb ? ' · ' + gb.getAttribute('data-prm-grind-title') : '';
      $(this.sticky, '[data-prm-sticky-price]').textContent = money(now, fmt);
      $(this.sticky, '[data-prm-sticky-label]').textContent = label;
      $(this.sticky, '[data-prm-sticky-btn]').disabled = !v.available;
    }

    // media for variant
    if (!first && v.featured_media && v.featured_media.id) {
      var thumb = this.root.querySelector('[data-prm-thumb][data-media-id="' + v.featured_media.id + '"]');
      if (thumb) thumb.click();
    }

    // URL (keeps ?view= for template previews)
    if (!first && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    this.root.dispatchEvent(new CustomEvent('prm:variant', { bubbles: true, detail: { variant: v, subscription: subOn } }));
  };
  Main.prototype.bindGallery = function () {
    var stage = $(this.root, '[data-prm-stage]');
    var thumbs = $$(this.root, '[data-prm-thumb]');
    if (!stage || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        stage.src = t.getAttribute('data-src');
        stage.srcset = t.getAttribute('data-srcset');
        stage.alt = t.getAttribute('data-alt');
        thumbs.forEach(function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-current'); });
        t.classList.add('is-active'); t.setAttribute('aria-current', 'true');
      });
    });
  };
  // Add to cart qua giỏ trượt của theme (Impulse theme.AjaxProduct) thay vì nhảy sang trang /cart.
  // AjaxProduct gửi form bằng serialize (bỏ input disabled) → selling_plan đã được lọc ở listener submit (capture) bên trên.
  // Không có theme.AjaxProduct (theme khác) → giữ submit thường.
  Main.prototype.bindAjaxCart = function () {
    var form = this.form, tries = 0;
    if (!form || form.__prmAjax) return;
    (function attach() {
      if (window.theme && typeof window.theme.AjaxProduct === 'function') {
        form.__prmAjax = new window.theme.AjaxProduct(form, '[data-prm-cta]');
      } else if (tries++ < 50) {
        setTimeout(attach, 200);
      }
    })();
  };

  Main.prototype.bindSticky = function () {
    var sticky = this.sticky, cta = this.cta, form = this.form;
    if (!sticky || !cta || !('IntersectionObserver' in window)) return;
    var btn = $(sticky, '[data-prm-sticky-btn]');
    btn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(cta); else cta.click();
    });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(cta);
  };

  /* ---------------- Infinite note rail (user-driven, no autoplay) ----------------
     Full clone set BEFORE and AFTER the originals. Rail opens with card 01 at the
     rail's start padding; once the user settles outside the middle set we shift
     scrollLeft by exactly one set width (snap + smooth disabled for that frame). */
  function loopRail(el) {
    if (el.__prmLoop) { el.__prmLoop.refresh(); return; }
    var originals = Array.prototype.slice.call(el.children).filter(function (c) { return !c.hasAttribute('data-prm-clone'); });
    if (originals.length < 2) return;
    var looped = false, setW = 0, startPos = 0, padL = 0, timer = null, touching = false, shifting = false, pending = false;
    var hasScrollEnd = 'onscrollend' in window;

    function makeClone(c) {
      var k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.setAttribute('data-prm-clone', '');
      k.removeAttribute('data-shopify-editor-block');
      k.removeAttribute('id');
      Array.prototype.forEach.call(k.querySelectorAll('a,button,input,select,textarea,[tabindex],[id],[data-shopify-editor-block]'), function (n) {
        n.removeAttribute('id');
        n.removeAttribute('data-shopify-editor-block');
        if (n.matches('a,button,input,select,textarea,[tabindex]')) n.setAttribute('tabindex', '-1');
      });
      k.style.scrollSnapAlign = 'start';
      return k;
    }
    function removeClones() {
      Array.prototype.slice.call(el.querySelectorAll(':scope > [data-prm-clone]')).forEach(function (c) { c.remove(); });
      originals.forEach(function (c) { c.style.scrollSnapAlign = ''; });
      el.style.scrollPaddingLeft = el.style.scrollPaddingRight = '';
      el.removeAttribute('data-looped');
      looped = false;
    }
    // scrollLeft that puts `card` at the rail's start padding
    function posOf(card) {
      return card.getBoundingClientRect().left - el.getBoundingClientRect().left + el.scrollLeft - padL;
    }
    function silentSet(x) {
      shifting = true;
      var snap = el.style.scrollSnapType, beh = el.style.scrollBehavior;
      el.style.scrollSnapType = 'none';
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = x;
      void el.offsetWidth;
      el.style.scrollSnapType = snap;
      el.style.scrollBehavior = beh;
      setTimeout(function () { shifting = false; }, 60);
    }
    // index (0-based, original order) of the card currently aligned at the rail start
    function currentIndex() {
      var kids = el.children, n = originals.length, rl = el.getBoundingClientRect().left + padL, best = 0, bd = Infinity;
      for (var i = 0; i < kids.length; i++) {
        var d = Math.abs(kids[i].getBoundingClientRect().left - rl);
        if (d < bd) { bd = d; best = i; }
      }
      return best % n;
    }
    function build(keepIdx) {
      removeClones();
      padL = parseFloat(getComputedStyle(el).paddingLeft) || 0;
      el.scrollLeft = 0;
      var last = originals[originals.length - 1];
      // always loop (even when all cards fit on wide screens) so the rail can always be swiped
      var first = el.firstChild;
      originals.forEach(function (c) { el.insertBefore(makeClone(c), first); });
      originals.forEach(function (c) { el.appendChild(makeClone(c)); c.style.scrollSnapAlign = 'start'; });
      el.style.scrollPaddingLeft = padL + 'px';
      el.style.scrollPaddingRight = (parseFloat(getComputedStyle(el).paddingRight) || 0) + 'px';
      el.setAttribute('data-looped', '1');
      looped = true;
      var after = el.querySelectorAll(':scope > [data-prm-clone]')[originals.length];
      startPos = posOf(originals[0]);
      setW = posOf(after) - startPos;
      silentSet(startPos + (keepIdx || 0) * (setW / originals.length));
    }
    function normalize() {
      if (!looped || shifting || touching || !setW) return;
      var x = el.scrollLeft, tol = 2;
      if (x < startPos - tol) silentSet(x + setW);
      else if (x >= startPos + setW - tol) silentSet(x - setW);
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { pending = false; normalize(); }, 120); }

    el.addEventListener('scroll', function () {
      if (!looped || shifting) return;
      var max = el.scrollWidth - el.clientWidth;
      if (el.scrollLeft < 4 || el.scrollLeft > max - 4) { silentSet(el.scrollLeft + (el.scrollLeft < 4 ? setW : -setW)); return; }
      if (!hasScrollEnd || pending) schedule();
    }, { passive: true });
    if (hasScrollEnd) el.addEventListener('scrollend', function () { if (!touching) { clearTimeout(timer); pending = false; normalize(); } });
    el.addEventListener('touchstart', function () { touching = true; clearTimeout(timer); }, { passive: true });
    function release() { touching = false; pending = true; schedule(); }
    el.addEventListener('touchend', release, { passive: true });
    el.addEventListener('touchcancel', release, { passive: true });

    // Mouse drag (desktop): click-and-drag to slide, then snap to the nearest card
    var drag = null, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !looped) return;
      drag = { x: e.clientX, left: el.scrollLeft }; moved = false; touching = true; clearTimeout(timer);
      el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto'; el.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) moved = true;
      if (moved) { e.preventDefault(); el.scrollLeft = drag.left - dx; }
    });
    function endDrag() {
      if (!drag) return;
      drag = null; el.style.cursor = '';
      var kids = el.children, rl = el.getBoundingClientRect().left + padL, target = null, bd = Infinity;
      for (var i = 0; i < kids.length; i++) { var d = Math.abs(kids[i].getBoundingClientRect().left - rl); if (d < bd) { bd = d; target = kids[i]; } }
      el.style.scrollSnapType = '';
      if (target) el.scrollTo({ left: posOf(target), behavior: reduceMotion ? 'auto' : 'smooth' });
      touching = false; pending = true; setTimeout(schedule, 350);
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.style.cursor = 'grab';

    var rz = null, lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return; // ignore mobile URL-bar height changes
      lastW = window.innerWidth;
      clearTimeout(rz);
      rz = setTimeout(function () { build(currentIndex()); }, 150);
    });
    window.addEventListener('load', function () { if (looped && !touching) build(currentIndex()); });

    el.__prmLoop = { refresh: function () { build(currentIndex()); } };
    build(0);
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(scope) {
    var tabs = $$(scope, '[data-prm-tab]'), panels = $$(scope, '[data-prm-panel]');
    if (!tabs.length) return;
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select((i + d + tabs.length) % tabs.length, true);
      });
    });
  }

  /* ---------------- Story toggle ---------------- */
  function initStory(root) {
    var btn = $(root, '[data-prm-story-toggle]');
    if (!btn) return;
    var label = $(btn, '[data-prm-story-label]');
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = btn.getAttribute(open ? 'data-open-label' : 'data-closed-label');
      observeReveals(root);
      if (!open) root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------------- Reveal ---------------- */
  var io = null;
  function observeReveals(scope) {
    var els = $$(scope, '[data-prm-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- Scroll to buy ---------------- */
  function initGoto(scope) {
    $$(scope, '[data-prm-goto]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var first = document.querySelector('.prm-main [role="radio"][aria-checked="true"], .prm-main [data-prm-cta]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
      });
    });
  }

  function init(scope) {
    $$(scope, '[data-prm-main]').forEach(function (el) { if (!el.__prm) el.__prm = new Main(el); });
    $$(scope, '[data-prm-rail]').forEach(loopRail);
    $$(scope, '[data-prm-tabs-scope]').forEach(initTabs);
    $$(scope, '[data-prm-story]').forEach(initStory);
    initGoto(scope);
    observeReveals(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
